import codePenSettings from "../media/codepenSetup/codepenSettings.png"
import addPhaser from "../media/codepenSetup/addPhaser.png"
import changeLayout from "../media/codepenSetup/changeLayout.png"
import Button from 'react-bootstrap/Button';

const Setup = () => <>
    <h1>Getting Started</h1>
    <p>We first need to setup our environment to get coding.</p>
    <ol>
    <li>Go to <a href="https://codepen.io/" target="_blank">https://codepen.io/</a></li>
    <li>Sign up using email or google account</li>
    <li>Click Start Coding</li>
    </ol>

    <p>We need to add the game library we are going to use to create the game.  Click on settings gear icon on top right of screen.</p>
    <img alt="Code pen settings image" src={codePenSettings} width={800} height={400}/>
    <br />
    <br />
    <h2>Configure Phaser</h2>
    <ol>
        <li>Select JS tab on top left corner.</li>
        <li>Type in 'phaser' inside the Add External Scripts/Pens input</li>
        <li>Click phaser from drop down</li>
        <li>Close window</li>
    </ol>
    <img alt="Add Phaser image" src={addPhaser} width={800} height={800}/>
    <br />
    <br />
    <h2>Changing Layout</h2>
    <ol>
        <li>Click on the change layout icon</li>
        <li>Click on the leftmost layout icon</li>
    </ol>
    <img alt="Layout image" src={changeLayout} width={800} height={500}/>

    <br />
    <br />
    <Button type="button" variant="secondary" href="/Config">Next</Button>
    <br />
    <br />

</>

export default Setup